import { ComplianceDocumentType } from "src/utils/documentSeriesEnum";
import { defineForm, MANUAL_DOC_ENDPOINTS } from "../../../../core";
import { vendorPreserve } from "../../../_shared/preserve";
import { verifactuDebitNoteSchema } from "./schema";

export const verifactuDebitNoteConfig = defineForm({
  id: "verifactu_debit_note",
  createEndpoint: MANUAL_DOC_ENDPOINTS.VERIFACTU_DEBIT_NOTE,
  permission: "ManualDocumentsIN_Write",
  seriesPermission: "ManualDocumentsSeries_Read",
  documentClass: "DebitNote",
  accountClass: "AccountReceivable",
  taxRatesChannel: "VeriFactu",
  invoiceType: "debitNote",
  complianceType: ComplianceDocumentType.DebitNote,
  requiresLegalRep: true,
  titleKey: "DebitNote",
  complianceStandardKey: "verifactu",
  schema: verifactuDebitNoteSchema,
  preserveOnReset: vendorPreserve,
  sections: {
    customer: { hiddenFields: ["customerCompanyAddress"] },
  },
  hiddenSections: ["recurring"],
  omitFromPayload: ["customerCompanyAddress"],
});
